import {EventEmitter, Injectable} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';
import {Observable} from 'rxjs/index';
import {AppConfig} from '../shared/common/app.config';

@Injectable({
  providedIn: 'root'
})
export class ChecklistService {

  constructor(private httpClient: HttpClient, private appConfig: AppConfig,
              private router: Router) {
  }

  baseUrl: string =  this.appConfig.getConfig('BASE_URL') + 'api/checklist/';
  private headers;
  public model = new EventEmitter<NgbModal>();
  private headersJson = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});


  getChecklist(): Observable<Object> {
    return this.httpClient.get(this.baseUrl + 'getChecklist');
  }


  getChecklistByType(type: string): Observable<Object> {
    return this.httpClient.get(this.baseUrl + 'getChecklist/'+ type);
  }

}
